module.exports = __webpack_public_path__ + "img/icon-link.8f8e587c.svg";